import React from 'react';
import { Box, Inline } from '@styleseat/ui';
import { Button } from '../../ui';
import { useResponsive } from '../../../hooks/useResponsiveEffect';
import { PROVIDER_GROWTH_SUMMARY, PRO_PROMOTE_PROFILE } from '../../../route-names';

type InsightsCTAsProps = {
  handleCtaPress: (object) => void;
  providerId: number;
  isHomeTab: boolean;
};

export const VIEW_INSIGHTS_CTA_CLICKED_EVENT = 'pro_view_insights_cta_clicked';
export const PROMOTE_PROFILE_CTA_CLICKED_EVENT = 'pro_promote_profile_cta_clicked';
export const InsightsCTAsViewInsightsTestId = 'pro-insights-ctas-view-insights-test-id';
export const InsightsCTAsPromoteProfileTestId = 'pro-insights-ctas-promote-profile-test-id';

const InsightsCTAs = ({
  handleCtaPress, providerId, isHomeTab,
}: InsightsCTAsProps) => {
  const { tablet, mobile } = useResponsive();

  return (
    <Box>
      <Inline
        justifyContent={isHomeTab ? 'space-around' : 'flex-start'}
        space={8}
        style={{
          marginTop: tablet || mobile ? 8 : 24,
        }}
      >
        <Button
          onClick={() => handleCtaPress({
            cta: PROVIDER_GROWTH_SUMMARY,
            event: VIEW_INSIGHTS_CTA_CLICKED_EVENT,
            options: {
              providerId,
              edit: 1,
            },
          })}
          text="view insights"
          appearance="text-light"
          size="small"
          testID={InsightsCTAsViewInsightsTestId}
          style={{
            width: '100%',
            textTransform: 'capitalize',
            borderRadius: 4,
            padding: 0,
          }}
        />
        <Button
          onClick={() => handleCtaPress({
            cta: PRO_PROMOTE_PROFILE,
            event: PROMOTE_PROFILE_CTA_CLICKED_EVENT,
            options: {
              providerId,
            },
          })}
          text="promote profile"
          appearance="text-light"
          size="small"
          testID={InsightsCTAsPromoteProfileTestId}
          style={{
            width: '100%',
            textTransform: 'capitalize',
            borderRadius: 4,
            padding: 0,
          }}
        />
      </Inline>
    </Box>
  );
};

export default InsightsCTAs;
